import { formComponents as fc } from "@/components/form";
import InviteForm from "../../invite/components/InviteForm";
import { useClinicianOptions } from "../../auth/api/cliniciansByOrganisationQuery";

interface Props {
    organisationId: string;
}
const ShockwaveFormFields = ({ organisationId }: Props) => {
    const clinicianOptions = useClinicianOptions(organisationId);
    return (
        <>
            <div>
                <fc.ComboBox
                    autoFocus
                    label="Referring Clinician"
                    name="referring_clinician_id"
                    description="The clinician who requests the shockwave therapy"
                    options={clinicianOptions}
                    clearable={true}
                    addOption={<InviteForm />}
                />
            </div>
            <div>
                <fc.ComboBox
                    label="Shockwave Therapist"
                    name="shockwaving_clinician_id"
                    description="The clinician who performs the shockwave therapy"
                    options={clinicianOptions}
                    clearable={true}
                    addOption={<InviteForm />}
                />
            </div>
        </>
    );
};

export default ShockwaveFormFields;
